
import React from 'react';
import { Link } from 'react-router-dom';

const ThankYou: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center px-4">
      <div className="max-w-md">
        <h1 className="text-4xl font-bold mb-6">Thanks for reaching out!</h1>
        <p className="text-xl mb-8">
          We've received your message and will get back to you shortly.
        </p>
        <Link 
          to="/" 
          className="inline-block bg-presintention-accent text-white py-3 px-8 rounded-lg hover:bg-opacity-90 transition-all"
        >
          Return to Homepage
        </Link>
      </div>
    </div>
  );
};

export default ThankYou;
